import React from 'react'
import { colors } from '@fs/zion-ui'
import { css } from '@linaria/core'

const countCss = css`
  font-weight: normal;
  color: ${colors.transparent.gray70};
`

export default function CountHeader({ title, count }) {
  return (
    <>
      <span>{title}</span>
      {count !== undefined && <span className={countCss}> ({count})</span>}
    </>
  )
}
